import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ConfigService } from '../../shared-services/config.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'lib-config-form',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TitleCasePipe,
    MatTabsModule,
    MatOptionModule,
    MatFormFieldModule,
    MatOptionModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './config-form.component.html',
  styleUrl: './config-form.component.scss'
})
export class ConfigFormComponent implements OnInit {
  configForm!: FormGroup;
  configData: any;


  ngOnInit() {
    this.configForm = this.fb.group({});
    this.service.getSimulateConfigData().subscribe(data => {
    this.configData = data;
    console.log('Fetched Config Data:', this.configData);
    this.buildForm();
    })
  }

  constructor(private fb: FormBuilder, private service: ConfigService, private snackBar: MatSnackBar) { }

  buildForm() {
    const factorGroups: any = {};
    const allFactors = [
      ...this.configData.kbf_factors,
      ...this.configData.quality_cost_factors,
      'actual_revenue',
      'actual_aftermarket_revenue',
      'quarter_cost_hp'
    ];

    allFactors.forEach(factor => {
      const data = this.configData[factor];
      factorGroups[factor] = this.fb.group({
        min: [data.min, Validators.required],
        max: [data.max, Validators.required],
        step: [data.step, Validators.required],
        max_increase_factor: [data.max_increase_factor, Validators.required],
        type: [data.type],
        direction: [data.direction]
      });
    });

    this.configForm = this.fb.group(factorGroups);
  }

onSubmit() {
  if (this.configForm.valid) {
    const updatedConfig = {
      kbf_factors: this.configData.kbf_factors,
      quality_cost_factors: this.configData.quality_cost_factors,
      ...this.configForm.value
    };

    console.log('Updated Config:', updatedConfig);

    this.service.saveSimulateConfigData(updatedConfig)
      .subscribe({
        next: () => {
          this.snackBar.open('Data updated successfully!', 'Close', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['snackbar-success'],
          });
        },
        error: (err) => {
          console.error('Save failed:', err);
          this.snackBar.open('Failed to save.', 'Close', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['snackbar-error'],
          });
        },
      });
  }
}

}
